import React from "react";
import HirePageBanner from "../components/HirePageBanner/HirePageBanner";
import DevelopmentPerformance from "../components/DevelopmentPerformance/DevelopmentPerformance";
import SecondFaq from "../components/secondFaq/SecondFaq";
import Footer from "../components/footer/Footer";
import MegaHeader from "../components/MegaHeader/MegaHeader";
import { Helmet } from "react-helmet";

// Only import the main content object
import { hireNodePageContent } from "../data/hireNodejsPageData";

import HirePageExperties from "../components/hirepageExperties/HirePageExperties";
import HirePageSteps from "../components/hire-page-steps/HirePageSteps";
import HireExpertFacts from "../components/hire-expert-facts/HireExpertFacts";
import HirePageEngagmentModels from "../components/hire-page-engagment-models/HirePageEngagmentModels";
import HirePageAppIdea from "../components/hire-page-app-idea/HirePageAppIdea";
import ContactSection from "../components/contactSection/ContactSection";
import TrendsInsights from "../components/trends-n-insights/TrendsInsights";
import HireCombinationSection from "../components/hire-combination-sectiono/HireCombinationSection";
import CoverTheStack from "../components/coverthestack/CoverTheStack";
import { useTranslation } from "react-i18next";
import SoftwareCompanyCta from "../components/software-company-cta/SoftwareCompanyCta";
import SimpleModels from "../components/simpleEngagementModels";
import MegaMenu from "../components/MegaMenu/MegaMenu";
import OurServices from "../components/our-services/OurServices";

const HireNode = () => {
  // Destructure the data from the imported object
  // const {
  //   helmet,
  //   mainBanner,
  //   nodeExpertise, // Updated name
  //   whyChooseUs,
  //   techCombinations,
  //   hireSteps,
  //   coverTheStack,
  //   expertFacts,
  //   appIdeaSection,
  //   hirePageEngagementModels,
  //   faqSection,
  // } = hireNodePageContent;

  const { t } = useTranslation("hireNodePage");
  const helmet = t("helmet", { returnObjects: true });
  const mainBanner = t("mainBanner", { returnObjects: true });
  const nodeExpertise = t("nodeExpertise", { returnObjects: true });
  const whyChooseUs = t("whyChooseUs", { returnObjects: true });
  const techCombinations = t("techCombinations", { returnObjects: true });
  const hireSteps = t("hireSteps", { returnObjects: true });
  const coverTheStack = t("coverTheStack", { returnObjects: true });
  const expertFacts = t("expertFacts", { returnObjects: true });
  const appIdeaSection = t("appIdeaSection", { returnObjects: true });
  const hirePageEngagementModels = t("hirePageEngagementModels", {
    returnObjects: true,
  });
  const faqSection = t("faqSection", { returnObjects: true });

  const { t: tengagementModelContent } = useTranslation(
    "engagementModelContent"
  );

  // grab the full object once
  const engagementModelsContent = {
    heading: tengagementModelContent("heading"),
    darkHeading: tengagementModelContent("darkHeading"),
    subheading: tengagementModelContent("subheading"),
    models: tengagementModelContent("models", { returnObjects: true }),
    cta: tengagementModelContent("cta", { returnObjects: true }),
  };

  const { t: tfooter } = useTranslation("footer");
  const footerCtaContent = tfooter("footerCtaContent", {
    returnObjects: true,
  });
  return (
    <>
      <Helmet>
        <title>{helmet.title}</title>
        <meta name="description" content={helmet.description} />
      </Helmet>

      <MegaMenu />

      <HirePageBanner
        diffBannerBackgroundImage={mainBanner.backgroundImage}
        image={mainBanner.image}
        mainHeading={mainBanner.mainHeading}
        content={mainBanner.content}
        btnText={mainBanner.btnText}
        bannerList={mainBanner.bannerList}
      />

      <OurServices
        mainHeading={nodeExpertise?.heading}
        description={nodeExpertise?.description}
        servicesCardsData={nodeExpertise?.servicesData}
        buttonText="Schedule a Call Today"
      />

      <DevelopmentPerformance
        buttonText={whyChooseUs.btnText}
        heading={whyChooseUs.heading}
        greenHeading={whyChooseUs.greenHeading}
        subHeading={whyChooseUs.subHeading}
        solutions={whyChooseUs.solutionsData}
      />

      <HireCombinationSection
        combinations={techCombinations.combinations}
        heading={techCombinations.heading}
        description={techCombinations.description}
      />

      <HirePageSteps
        buttonText={hireSteps.btnText}
        heading={hireSteps.heading}
        subHeading={hireSteps.subHeading}
        steps={hireSteps.steps}
      />

      <CoverTheStack
        whereStart={coverTheStack.whereStart}
        mainHeading={coverTheStack.mainHeading}
        subHeading={coverTheStack.subHeading}
        tabs={coverTheStack.tabs}
        tabItems={coverTheStack.tabItems}
      />

      <HireExpertFacts
        buttonText={expertFacts.btnText}
        heading={expertFacts.heading}
        greenHeading={expertFacts.greenHeading}
        facts={expertFacts.facts}
        diffBannerBackgroundImage={expertFacts.backgroundImage}
      />

      <HirePageAppIdea
        heading={appIdeaSection.heading}
        content={appIdeaSection.content}
      />

      {/* <HirePageEngagmentModels
        buttonText={hirePageEngagementModels.btnText}
        heading={hirePageEngagementModels.headingContent}
        content={hirePageEngagementModels.discription}
        hiringDetails={hirePageEngagementModels.hiringDetails}
      /> */}

      <SimpleModels content={engagementModelsContent} />

      <TrendsInsights specificClass="mobile-dev-page" category="all" />

      <SecondFaq
        faqs={faqSection.faqData}
        specificClass="mobile-dev-page"
        mainHeading={faqSection.mainHeading}
        subHeading={faqSection.subHeading}
      />

      {/* <ContactSection /> */}

      <SoftwareCompanyCta content={footerCtaContent} />

      <Footer />
    </>
  );
};

export default HireNode;
